import { routes } from 'constants/config';
import createRoutesMatcher from './createRoutesMatcher';

const PERMITTED_ROUTES = {
  VISIBLE: new Set(),
  // predefined set of routes to be considered permitted
  INVISIBLE: new Set([
    routes.LEARN_TOPICS + '.*', // a single topic
  ]),
};

class PermittedRoutes {
  static get first() {
    return Array.from(PERMITTED_ROUTES.VISIBLE)[0];
  }

  static register(route) {
    PERMITTED_ROUTES.VISIBLE.add(route);
  }

  static isPermitted(pathname) {
    const matchesAnyOf = createRoutesMatcher(pathname);
    return matchesAnyOf([
      ...PERMITTED_ROUTES.VISIBLE,
      ...PERMITTED_ROUTES.INVISIBLE,
    ]);
  }
}

export default PermittedRoutes;
